import { graphql } from '@/client/services/api/graphql/gql';

export const sendExchangeFeedbackMutation = graphql(`
  mutation AddAiExchangeFeedback($feedbackInput: FeedbackInput!, $id: String!) {
    addFeedback(feedbackInput: $feedbackInput, id: $id)
  }
`);
